import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule } from "@angular/router";
import { ClickableDataCardComponent } from "@shared/components/cards/clickable-data-card/clickable-data-card.component";
import { SkeletonModule } from "primeng/skeleton";
import { WalletService } from "../../../app/services/wallet.service";
import { LastEventsPageComponent } from "../../../app/shared/components/producer-area/pages/last-events-page/last-events-page.component";
import { LastSalesPageComponent } from "../../../app/shared/components/producer-area/pages/last-sales-page/last-sales-page.component";
import { PaymentMethodsChartPageComponent } from "../../../app/shared/components/producer-area/pages/payment-methods-chart-page/payment-methods-chart-page.component";
import { SalesChannelsChartPageComponent } from "../../../app/shared/components/producer-area/pages/sales-channels-chart-page/sales-channels-chart-page.component";
import { RevenueGraphicPageComponent } from "../../../app/shared/components/producer-area/pages/revenue-graphic-page/revenue-graphic-page.component";
import { TicketsInfoPageComponent } from "../../../app/shared/components/producer-area/pages/tickets-info-page/tickets-info-page.component";
import { AppLayoutComponent } from "../app-layout/app-layout.component";
import { PageHeaderComponent } from "../page-header/page-header.component";

@Component({
  selector: "app-producer-area",
  imports: [
    CommonModule,
    AppLayoutComponent,
    MatButtonModule,
    SkeletonModule,
    PageHeaderComponent,
    ClickableDataCardComponent,
    MatIconModule,
    LastEventsPageComponent,
    RevenueGraphicPageComponent,
    TicketsInfoPageComponent,
    RouterModule,
    LastSalesPageComponent,
    PaymentMethodsChartPageComponent,
    SalesChannelsChartPageComponent,
  ],
  templateUrl: "./producer-area.component.html",
  styleUrl: "./producer-area.component.scss",
})
export class ProducerAreaComponent {
  private readonly _walletService = inject(WalletService);

  wallet$ = this._walletService.getWallet();
}
